// extracted by mini-css-extract-plugin
export default {"modal-content":"modal-content-ccfb","carousel":"carousel-8822"};